import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { PositionDescriptionType } from './position-description-type';

export class PositionDescriptionTypeService {
   async getPositionDescriptionTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<PositionDescriptionType>>>(`/position-description-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
